import {
  useEffect, useContext, useRef, useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useIsEventClosedMemo from 'hooks/useIsEventClosedMemo';
import { fetchCachedCMSData } from 'models/cms/common/thunks';
import { UserSessionContext } from 'components/UserSession';
import { SplitioContext, SplitioFeature } from 'components/SplitioContext';
import { fetchQuestions } from 'models/questions';

const useCachedCMSDataEffect = () => {
  const init = useRef({
    xtraCMS: false,
  });

  const dispatch = useDispatch();
  const { userSession } = useContext(UserSessionContext);
  const authToken = useMemo(() => (userSession || {}).authToken, [userSession]);
  const { features } = useSelector((s: any) => s.eventConfigs);
  const supportParticipantFiltering = useMemo(() => features.includes('hktdcFiltering'), [features]);
  const useCachedCMSData = useMemo(() => features.includes('useCachedCMSData'), [features]);
  const { isReady: isSplitioReady, isTreatmentOn } = useContext(SplitioContext);
  const isEventClosed = useIsEventClosedMemo();

  useEffect(() => {
    if (isEventClosed) {
      return;
    }
    if (!init.current.xtraCMS && isSplitioReady) {
      init.current.xtraCMS = true;
      if (authToken && useCachedCMSData && isTreatmentOn(SplitioFeature.useCachedCMSData)) {
        dispatch(fetchCachedCMSData()).then((result) => {
          if (result?.type?.endsWith('rejected')) {
            console.error('ERROR: Cannot access cached CMS data');
          }
        });
      }
    }
    if (supportParticipantFiltering) {
      dispatch(fetchQuestions());
    }
  }, [
    dispatch,
    isEventClosed,
    isSplitioReady,
    authToken,
    useCachedCMSData,
    isTreatmentOn,
    supportParticipantFiltering,
  ]);
};

export default useCachedCMSDataEffect;
